module.exports = __webpack_public_path__ + "img/00ee712.png";